import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import "./ConfirmDialog.css";

/**
 * Site-styled confirmation modal (replaces window.confirm for key actions).
 */
function ConfirmDialog({
  open,
  title,
  message,
  children,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
  confirmTone = "brand",
}) {
  const confirmClass =
    confirmTone === "danger"
      ? "site-dialog-btn site-dialog-btn--danger"
      : "site-dialog-btn site-dialog-btn--confirm";

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      className="site-dialog"
      PaperProps={{ className: "site-dialog-paper" }}
      aria-labelledby="site-dialog-title"
      aria-describedby="site-dialog-description"
    >
      <DialogTitle id="site-dialog-title" className="site-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent className="site-dialog-content">
        {children || (
          <p id="site-dialog-description" className="site-dialog-message">
            {message}
          </p>
        )}
      </DialogContent>
      <DialogActions className="site-dialog-actions">
        <Button
          type="button"
          variant="outlined"
          size="small"
          className="site-dialog-btn site-dialog-btn--cancel"
          onClick={onCancel}
          disabled={loading}
        >
          {cancelLabel}
        </Button>
        <Button
          type="button"
          variant={confirmTone === "danger" ? "outlined" : "contained"}
          size="small"
          className={confirmClass}
          onClick={onConfirm}
          disabled={loading}
          disableElevation
        >
          {loading ? `${confirmLabel}…` : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
